import { Button } from '@/components/ui/button'

export default function ContactsPage() {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-6">Contacts</h1>
      <p className="text-gray-500">Contacts management - coming soon</p>
      <Button variant="outline" className="mt-4">
        Add Contact
      </Button>
    </div>
  )
}
